import React from 'react';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';


class LoginFailed extends React.Component {

  render() {
    const { translate } = this.props;

    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <h1>{translate('login_failed_title')}</h1>
            <p>{translate('login_failed_text')}</p>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
});

export default connect(
  mapStateToProps,
  null,
)(LoginFailed);



// WEBPACK FOOTER //
// ./src/views/LoginFailed.js